<template>
  <div class="textbox" :style="{zIndex: zIndex}" v-if="visible">
    <div class="textbox-container"  contenteditable="true" @cut.stop @blur="updateTextbox()" id="textbox" :style="textStyle" v-html="text"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import textArtStyle from '@/components//mixins/textArtStyle';
export default {
  mixins: [textArtStyle],
  name: 'Textbox',
  data() {
    return {
      visible: false,
      id: Number,
      scenesId: Number,
      zIndex: Number,
      text: String,
      textStyle: {
        fontSize: String,
        fontFamily: String,
        fontWeight: String,
        fontStyle: String,
        textDecoration: String,
        textAlign: String,
        color: String,
        opacity: Number,
        width: String,
        top: String,
        left: String,
        lineHeight: Number,
        letterSpacing: String
      }
    };
  },
  computed: {
    ...mapGetters([
      'TopNav_Size',
      'TOOL',
      'ToolScroll_Size',
      'SelectSprites_Msg'
    ]),
  },
  watch: {
    'SelectSprites_Msg'(val, oldVal) {
      if (this.visible) {
        this.updateTextbox();
      }
    }
  },
  mounted() {
    this.$bus.on('updateText', (data) => {
      this.$store.commit('toggle_isPreventDefault', false);
      this.sprite = data;
      this.sprite.action = 'changeTextbox';
      setTimeout(() => {
        data.showHideHandle(false);
        if (window.getSelection) {
          let selection = window.getSelection();
          let range = document.createRange();
          range.selectNodeContents(document.getElementById('textbox'));
          selection.removeAllRanges();
          selection.addRange(range);
        }
        document.getElementById('textbox').addEventListener('paste', (e) => {
          // Prevent the default pasting event and stop bubbling
          // e.preventDefault();
          // e.stopPropagation();

          // // Get the clipboard data
          // let paste = (e.clipboardData || window.clipboardData).getData('text');

          // // Do something with paste like remove non-UTF-8 characters
          // paste = paste.replace(/<\/?span.*?>/g, '');

          // // Find the cursor location or highlighted area
          // const selection = window.getSelection();

          // // Cancel the paste operation if the cursor or highlighted area isn't found
          // if (!selection.rangeCount) return false;

          // // Paste the modified clipboard content where it was intended to go
          // selection.getRangeAt(0).insertNode(document.createTextNode(paste));

          e.preventDefault();
          e.stopPropagation();
          var text;
          var clp = (e.originalEvent || e).clipboardData;
          if (clp === undefined || clp === null) {
            text = window.clipboardData.getData("text") || "";
            if (text !== "") {
              if (window.getSelection) {
                var newNode = document.createElement("span");
                newNode.innerHTML = text;
                window.getSelection().getRangeAt(0).insertNode(newNode);
              } else {
                document.selection.createRange().pasteHTML(text);
              }
            }
          } else {
            text = clp.getData('text/plain') || "";
            if (text !== "") {
              document.execCommand('insertText', false, text);
            }
          }
        });
      }, 100);
      this.visible = true;
      this.zIndex = 999;
      this.text = data.text;
      this.id = data.id;
      this.scenesId = data.scenesId;
      this.textStyle = {
        fontSize: data.font.fontSize / data.editor.scale + 'px',
        fontFamily: '"' + data.font.fontFamilyUrl.split('/').pop() + '"',
        fontWeight: data.font.fontWeight,
        fontStyle: data.font.fontStyle,
        textDecoration: data.font.textDecoration,
        textAlign: data.font.textAlign,
        color: data.font.color,
        opacity: data.font.opacity,
        top: data.positionTop + data.editor.fixTop - this.ToolScroll_Size.top + 'px',
        left: data.positionLeft + data.editor.fixLeft - this.ToolScroll_Size.left + 'px',
        transform: `rotate(${data.rotate}deg)`,
        lineHeight: parseFloat(data.lineHeight) || 1,
        letterSpacing: parseFloat(data.letterSpacing * (~~(parseInt(data.font.fontSize) / 10)) || 0) / data.editor.scale + 'px',

      };
      switch(data.versionAnyway){
        case 'Vertical':
          this.textStyle.writingMode = 'vertical-rl';
          this.textStyle.height = data.height + 'px';
          break;
        default:
          this.textStyle.writingMode = 'inherit';
          this.textStyle.width = data.width + 'px';
      }

      if (this.sprite.artType) {
        this.textStyle = Object.assign(this.textStyle, this.getStyle(data.artType, data.font.color, data.font.fontSize / data.editor.scale))
      }
    });
  },
  methods: {
    updateTextbox(ev) {
      // console.log('更新文本框');
      // ev && ev.preventDefault();
      // ev.stopPropagation();
      let modifiedText = this.$el.childNodes[0].innerHTML
          .replace(/<div><br><\/div>/g, '\n')
          .replace(/<div.*?>/g, '\n')
          .replace(/<br.*?>/g, '')
          .replace(/<\/div>|&nbsp;|<\/?span.*?>/g, '');
      // 鼠标点击文本框以外的地方时更新到画布
      this.visible = false;
      this.sprite.showHideHandle(true);
      this.sprite.ele.show();
      this.TOOL.disabled = false;
      // 没修改不update
      if (this.text !== modifiedText) {
        if(modifiedText === "") modifiedText = "添加正文";
        this.TOOL.updateSprite(this.id, {
          text: modifiedText,
          // font: this.textStyle.font,
        }, this.scenesId, true);
      }
      this.$store.commit('toggle_isPreventDefault', true);
      this.TOOL.disabledEditor(1);
      this.sprite.action = null;
      this.TOOL.selectSprite([this.sprite]);
      // 输入文字高度超出画布高度，退出编辑状态后拉回视野
      document.getElementById('app').scrollTop = 0;
      document.getElementById('app').scrollLeft = 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.textbox {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  .textbox-container {
    position: absolute;
    border: 1px dashed #000;
    height: auto;
    word-break: break-word;
    outline: none;
    white-space: pre-wrap;
    box-sizing: content-box;
    -webkit-user-select: text !important;
    user-select: text !important;
    -webkit-background-clip: text;
    background-clip: text;
    caret-color: black;
    // -webkit-user-modify: read-write-plaintext-only;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/textbox.vue